<template>
  <div>
    <div class="radio">
      <div v-for="option in options" :key="option.key">
        <label class="radio-button-description">
          <input
            type="radio"
            :name="name"
            @click="changeValue(option.key)"
            :checked="value === option.key"
            :value="option.key"
            :id="getAnalyticsId(option.key)"
          >
          {{option.description}}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'radio-button-selector',
  props: {
    options: {
      type: Array
    },
    optionsAnalyticsData: {
      type: Object
    },
    value: {
      type: [String, Number]
    },
    name: {
      type: String
    }
  },
  methods: {
    changeValue: function (newValue) {
      this.$emit('input', newValue);
    },
    getAnalyticsId(choiceKey) {
      if (this.optionsAnalyticsData) {
        return this.optionsAnalyticsData[choiceKey] || null;
      }
    },
    onfocus() {
      this.scrollToActiveElement();
      this.$emit('focus');
    }
  }
};
</script>

<style lang="scss">
  .radio-button-description {
    font-size: 16px;
    font-weight: 400;
    padding-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/radio-button-selector.vue